export const state = {
  translation_fe_tree: null,
  translation_db_tree: null,
};
